import React, {useState} from 'react';
import {useGetFinBalancePointProductsQuery} from '../../../redux/DepotSlice/depotReportApi';
import s from '../FinancialReport.module.css';
import style from '../../PaperworkList/PaperworkList.module.css';
import GridTableHead from '../../../Components/GridTableHead/GridTableHead';
import PreLoaderComponent from '../../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import {useTranslation} from 'react-i18next';
import {monthNow} from '../../../assets/utils/dateUtils';

const FinBalancePointProducts: React.FC = () => {
	const {t} = useTranslation();
	const [month, setMonth] = useState<string>(monthNow());
	const {data, isLoading} = useGetFinBalancePointProductsQuery(month);

	return (
		<>
			<div className={s.title}>{t('Баланс балової продукції')}</div>

			{/* Таблиця */}
			{isLoading ? (
				<PreLoaderComponent type={'gallery'} size={'big'} />
			) : (
				data &&
				data.points &&
				data.money && (
					<div className={s.reportTableContainer}>
						<div className={s.marginTop} />
						<GridTableHead
							columns={[
								'',
								'Залишок на початок',
								'Прийшло',
								'Оформлено',
								'Залишок на кінець',
							]}
							gridTemplateColumns="repeat(5, 1fr)"
							customClassName={s.tableRow}
						/>
						{/* Ряд з балами */}
						<div
							className={`${style.tableRow} ${s.tableRow}`}
							style={{gridTemplateColumns: 'repeat(5, 1fr)'}}
						>
							<div className={s.tableColumn}>
								<strong>{t('Бали')}</strong>
							</div>
							<div className={s.tableColumn}>{data.points.start}</div>
							<div className={s.tableColumn}>{data.points.income}</div>
							<div className={s.tableColumn}>{data.points.orders}</div>
							<div className={s.tableColumn}>{data.points.end}</div>
						</div>

						{/* Ряд з вартістю */}
						<div
							className={`${style.tableRow} ${s.tableRow}`}
							style={{gridTemplateColumns: 'repeat(5, 1fr)'}}
						>
							<div className={s.tableColumn}>
								<strong>{t('Вартість')}</strong>
							</div>
							<div className={s.tableColumn}>{data.money.start}</div>
							<div className={s.tableColumn}>{data.money.income}</div>
							<div className={s.tableColumn}>{data.money.orders}</div>
							<div className={s.tableColumn}>{data.money.end}</div>
						</div>
					</div>
				)
			)}
		</>
	);
};

export default FinBalancePointProducts;
